// lib/session.ts
//
// All @mango-engineering/makro-oauth-sdk imports are DYNAMIC (inside function
// bodies) so this module has zero static deps on the SDK. This keeps jose
// (JWT crypto, ~65KB) out of the initial bundle even though session.ts is
// transitively imported by Search.context.tsx via cart/trending services.

import { config } from '@/configs/env';

export type RefreshResult =
  | { status: 'ok'; sid?: string }
  | { status: 'expired' }
  | { status: 'error'; httpStatus?: number };

// Lazy singleton — created on first use, never at module load time.
let _refresher: { refreshOnce: () => Promise<RefreshResult> } | null = null;

const getRefresher = async () => {
  if (!_refresher) {
    const { createSessionRefresher, isReactNativeWebView } =
      await import('@mango-engineering/makro-oauth-sdk/client');
    _refresher = createSessionRefresher({
      sessionApiUrl: config.SESSION_API_URL,
      getSessionHeaders: () => ({
        Accept: 'application/json',
        'x-request-source': isReactNativeWebView() ? 'app' : 'web',
        'X-Request-ID': crypto.randomUUID(),
      }),
    });
  }
  return _refresher;
};

// Matches the shape api-service.ts expects: { refreshOnce }
export const sessionRefresher = {
  refreshOnce: () => getRefresher().then((r) => r.refreshOnce()),
};
